import { Button, Typography } from 'antd';
import BenefitRow from './BenefitRow';

const { Text } = Typography;

/**
 * 权益分类区块 - 展示单个分类标题、已选数量、选择权益按钮和权益行列表
 * @param {Object} props
 * @param {number} props.categoryId 分类 id
 * @param {string} props.categoryName 分类名称
 * @param {Array} props.benefits 该分类下已选权益列表
 * @param {Function} props.onSelectBenefit 点击"选择权益"按钮的回调
 * @param {Function} props.onBenefitChange 权益行数据变化回调 (conferenceBenefitId, updatedBenefit)
 * @param {Function} props.onRemoveBenefit 移除权益回调 (conferenceBenefitId)
 * @param {Object}  [props.benefitErrors] 校验错误集合 { [conferenceBenefitId]: { quantity?, boothNumbers? } }
 * @param {boolean} [props.isEditMode]   是否为编辑模式（透传给 BenefitRow）
 * @param {import('react').ReactNode} [props.headerExtra] 分类标题右侧附加内容（如查看会场规划图入口）
 */
export default function BenefitCategorySection({ categoryId, categoryName, benefits = [], onSelectBenefit, onBenefitChange, onRemoveBenefit, benefitErrors = {}, isEditMode = false, headerExtra = null }) {
    const count = benefits.length;

    return (
        <div className="benefit-category-section">
            <div className="benefit-category-header">
                <span className="benefit-category-title">
                    权益分类：{categoryName}
                    {count > 0 && (
                        <Text type="secondary" style={{ marginLeft: 4 }}>
                            （{count}项）
                        </Text>
                    )}
                    {headerExtra && <span style={{ marginLeft: 8 }}>{headerExtra}</span>}
                </span>
            </div>
            <div className="benefit-category-list">
                {benefits.length > 0 ? (
                    benefits.map(b => <BenefitRow key={b.conferenceBenefitId} benefit={b} onChange={updated => onBenefitChange(b.conferenceBenefitId, updated)} onRemove={() => onRemoveBenefit(b.conferenceBenefitId)} isEditMode={isEditMode} errors={benefitErrors[b.conferenceBenefitId] || {}} />)
                ) : (
                    <div className="benefit-category-empty">
                        <Text type="secondary">暂未选择权益</Text>
                    </div>
                )}
                <Button type="dashed" block className="benefit-add-btn" onClick={() => onSelectBenefit(categoryId, categoryName)}>
                    <i className="bi bi-plus-circle" style={{ marginRight: 4 }} />
                    添加权益
                </Button>
            </div>
        </div>
    );
}
